import type { FunctionComponent } from "react";
import { Text } from "~/components/ui";

interface PredefinedTaskTitleProps {
  order: number;
  title: string;
}

export const PredefinedTaskTitle: FunctionComponent<PredefinedTaskTitleProps> = ({ order, title }) => {
  return (
    <Text strong className="text-base">
      {order}. {title}
    </Text>
  );
};
